/**
 * @Copyright 2014-2017 DataVoke, Inc. All rights reserved.
 */
"use strict";

import 'jquery-ui/themes/base/base.css';

import coactiveAscii from './coactiveAscii';

coactiveAscii();
// console.log('Hey! Listen! We\'re Hiring! Visit http://coactiveapps.com/careers/');

//** This is to turn on or off alerts for debugging process flow. Be careful!
window.debugging = false;

//** This determines if the project uses local client components (latest version)
//from the linked client project (true) or if it uses the files downloaded from
//the service (false).
window.useLocal = true;

window.onerror = function onerror(msg, url, line, col, error) {
    console.error(msg, url, line, col, error);
};

// These will be transformed by @babel/preset-env to only polyfill what is needed for the current environment
import "core-js/stable";
import "regenerator-runtime/runtime";

import './polyfills';
import 'imports-loader?jQuery=jquery!jquery-ui';
import 'imports-loader?jQuery=jquery!jquery-format';
import 'imports-loader?$=jquery&draggable=jquery-ui/ui/widgets/draggable!jquery-ui-touch-punch';
import 'imports-loader?jQuery=jquery!jquery-hotkeys';
import ko from 'knockout';
import appVm from './appViewModel';

// global reference for knockout, if we are running visual client.
// app.useLocal = window.useLocal;

function deviceReady () {
    ko.applyBindings(appVm);
}

window.isNativeApp = process.env.IS_CORDOVA; // This will be set at build time
if (window.isNativeApp) {
    // we are running as a cordova app on a device
    document.addEventListener("deviceready", deviceReady, false);
}
else {
    // we are running in a browser
    document.addEventListener("DOMContentLoaded", deviceReady);
}
